/**
 * Carousels
 *  
 * HTML authors need to do the following:
 * * Apply this class to the parent element: "js-carousel"
 * * Apply this class on each container that needs to update dynamically: "js-carousel-view"
 * * Apply this class on each item that would change in the view: "js-carousel-item"
 */

import Carousel from './Carousel';

const cssClasses = {
    carousel: 'js-carousel',
    carouselView: 'js-carousel-view',
    carouselItem: 'js-carousel-item',
    next: 'js-carousel-button_next',
    previous: 'js-carousel-button_previous',
};

export default class Carousels {
    constructor(rootCssClass, subType) {
        this._all = [];
        this._rootCssClass = rootCssClass ? rootCssClass : cssClasses.carousel;
        this._subType = subType ? subType : Carousel;
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    _init() {
        // Get all the carousels.
        const carouselElements = document.getElementsByClassName(this._rootCssClass);

        if (!carouselElements || !carouselElements.length) {
            return;
        }

        for (let i = 0; i < carouselElements.length; i++) {
            const carouselElement = carouselElements[i];

            // Get all the views for the carousel.
            const carouselViewElements = carouselElement.getElementsByClassName(cssClasses.carouselView);
            if (!carouselViewElements || !carouselViewElements.length) {
                continue;
            }

            const carouselViews = [];
            for (let i = 0; i < carouselViewElements.length; i++) {
                const carouselViewElement = carouselViewElements[i];

                // Get all the items for the views.
                const carouselItemElements = carouselViewElement.getElementsByClassName(cssClasses.carouselItem);
                if (!carouselItemElements || !carouselItemElements.length) {
                    continue;
                }

                const carouselItems = [];
                for (let i = 0; i < carouselItemElements.length; i++) {
                    const carouselItemElement = carouselItemElements[i];
                    carouselItems.push(carouselItemElement);
                }

                carouselViews.push(carouselItems);
            }

            const nextElements = carouselElement.getElementsByClassName(cssClasses.next);
            const previousElements = carouselElement.getElementsByClassName(cssClasses.previous);

            this._all.push(
                new this._subType(
                    carouselElement,
                    carouselViews,
                    carouselViews[0].length,
                    nextElements, previousElements));
        }
    }
}
